import { useEffect, useState } from 'react';
import { getIntlErrorMessage as genericIntlErr, AppKey, useTranslation, TranslateFn } from '@blocs.i18n';
import { helpers } from '@minecraft.utils';

// Errors will fall back to the translated value in
// common.json under `globalError.${errorKey}` (see values in minecraft/src/components/utils/helpers/ErrorMessages.ts)
// to set a specific message pass a create or use a prefix in IntlErrorPrefix based
// on the page where you are customizing the error, then set a value in
// login.json under `${prefix}.error.${errorKey}`

// for example if you need to customize the message for a internalServiceError
// on the VerifyEmail page, then set the custom translation under login:verifyEmail.error.internalServiceError
export enum IntlErrorPrefix {
  FORGOT_USERNAME = 'forgotUsername',
  PASSWORD_RESET = 'passwordReset',
  VERIFY_LINK = 'verifyLink',
  VERIFY_EMAIL = 'verifyEmail',
  LOGIN = 'login',
  SIGNUP = 'signup',
}

type UpdateState = React.Dispatch<React.SetStateAction<string>>;
type ReturnType = [string, UpdateState];

export const getIntlErrorMessage = (
  t: TranslateFn,
  error: helpers.ErrorDataType,
  prefix?: IntlErrorPrefix,
  errorNamesToSkip?: Array<string>
): string => {
  return genericIntlErr(t, error, AppKey.LOGIN, prefix, errorNamesToSkip);
};

export const useIntlErrorMessage = (
  error: helpers.ErrorDataType,
  prefix?: IntlErrorPrefix,
  errorNamesToSkip?: Array<string>
): ReturnType => {
  const { t } = useTranslation();
  const [stateErrorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (error) {
      const errMsg = getIntlErrorMessage(t, error, prefix, errorNamesToSkip);

      if (errMsg) {
        setErrorMessage(errMsg);
      }

      window.scrollTo(0, 0);
    }
  }, [prefix, error, t, errorNamesToSkip]);

  return [stateErrorMessage, setErrorMessage];
};
